import { QuestionnaireFormQuestion, QuestionnaireFormValues } from 'types/ui';

const useInitialValues = (
  questions: QuestionnaireFormQuestion[],
  valueAsQuestion?: boolean,
): QuestionnaireFormValues => {
  return questions.reduce((values, question) => {
    return {
      ...values,
      [question.questionReference]: valueAsQuestion ? question : '',
    };
  }, {});
};

export default useInitialValues;
